import { type FeatureFlag, StoreKit } from '@nx/state';

export const isFeatureFlagEnabled = (flag: FeatureFlag) => {
  const { globalStore } = StoreKit.UNSAFE_getGlobalStoreInstance();
  const state = globalStore.getState();
  return state.featureFlags[flag];
};
